<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center m-0">
         <CCol sm="12" lg="12" class="">
            
            <div class="d-sm-down-none"> 
           </div>
              <CRow sm="12" lg="12" class="justify-content-center mt-5 m-0">
                <CCol col="12" md="6">
                  <CCard
                    v-for="item in quizHistory"
                    v-bind:key="item.Id"
                    style="border-radius: 20px"
                    class="box-shadow"
                  >
                    <div
                      style="
                        border-top-right-radius: 10px;
                        border-top-left-radius: 10px;
                      "
                      class="bg-gradient-turqouise-no p-2"
                    >
                      <div class="row">
                        <div class="col-10">

                          <h6 class="custom-font mt-2 text-left ml-2">
                            Quiz Title: {{ item.title }}
                          </h6>
                        </div>

                        <div class="col-2">
                          <CLink
                            class="card-header-action btn-minimize"
                            @click="GoToPageQuizDetail(item.quizScoreId)"
                            v-c-tooltip.hover.click="
                              'Click to view the Detail!'
                              "
                          >
                            <CIcon name="cil-arrow-thick-right" class="text-left text-white" />
                          </CLink>
                        </div>
                      </div>
                    </div>

                    <div class="text-left ml-3">
                       <h6 class="custom-font mt-4">
                          Quiz Id: <strong>{{ item.quizId }} </strong>
                        </h6>
                      <h6 class="custom-font">
                        Subject: <strong>{{ item.subjectName }}</strong>
                      </h6>
                      <h6 class="custom-font">
                        Grade: <strong>{{ item.gradeName }}</strong>
                      </h6>
                      <h6 class="custom-font">
                        Total Question: <strong>{{ item.questionCount }}</strong>
                      </h6>
                      <h6 class="custom-font">
                        Student Score: <strong>{{(item.quizPercentage.toFixed(2)) + "%" }}</strong>
                      </h6>
                      <h6 class="custom-font">
                        Timer: <strong>{{ item.TimerString }}</strong>
                      </h6>
                      <h6 class="custom-font">
                        Publish By: <strong>{{ item.TeacherName }}</strong>
                      </h6>
                      <br />
                    </div>
                    
                  </CCard>
                </CCol>
              </CRow>
              <div>
                <CButton
                  color="success"
                  class="custom-btn mt-1 mb-4"
                  size="lg"
                  block
                  :disabled="isDisabled"
                  @click="GoToDashBoard"
                >Close</CButton>
              </div>
      
      </CCol>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderWebStudent.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      quizHistory: [],
      SubmittedForm: false,
      Error: false
    };
  },
  async mounted() {
    this.GetQuizStudentHistory();
    this.GetSubject();
    this.GetGrade();
  },
  computed: {},
  methods: {

    async GetQuizStudentHistory() {
      this.$API
        .get(
          this.$QuizStudentHistoryByQuiz +
            "?studentId=" +
            this.$route.query.studentId +
            "&subjectId=" +
            this.$route.query.subjectId, 
             {
          withCredentials: true
          }
        )
         .then(response => {
         
          if (response.status == 200 && response.data != null) {
             this.quizHistory = response.data;
            console.log(this.quizHistory);
          }
        })

        .catch(function(error) {
          console.log(error.response);
           });
        // .then(
        //   function(response) {
        //     this.quizHistory = response.data;
        //   }.bind(this)
        // )
        // .catch(function(error) {
        //   console.log(error.response);
        // });
    },

    GoToPageQuizDetail(quizScoreId) {
      this.$router.push(
        "/QuizStudentQuizDetail?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId +
          "&quizScoreId=" +
          quizScoreId
      );
    },

     GoToDashBoard() {
      this.$router.push(
        "/QuizStudentExam?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },



  }
};
</script>
